import React, {useEffect, useState} from "react";
import "./CardGame.sass";
import Window from "../../_containers/window/Window";
import Card from "./Card";
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import VolumeOffOutlinedIcon from '@mui/icons-material/VolumeOffOutlined';
import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
import {icons} from "./helper";
import {ADDRESS} from "../../_api/client";
import CircleButton from "../../_components/common/buttons/CircleButton";
import CloseIcon from '@mui/icons-material/Close';
import {useNavigate} from "react-router";
import {TRAINERS_PAGE} from "../../common/links";

export default function CardGame() {
    const [audio] = useState(new Audio(ADDRESS + "/game/game-card.mp3"))

    const [intervalId, setIntervalId] = useState(-1);
    const [volume, setVolume] = useState(false)
    const [timer, setTimer] = useState(0);
    const [progress, setProgress] = useState(0)
    const [first, setFirst] = useState(-1);
    const [second, setSecond] = useState(-1);
    const [items, setItems] = useState([])
    const [cards, setCards] = useState([])

    const navigate = useNavigate();

    useEffect(() => {
        setItems(Array(24).fill().map(i => false))

        const resCard = [];
        let i = 0;
        icons.forEach((icon, n) => {
            const res = {
                type: n,
                icon: icon
            }
            resCard[i] = res;
            resCard[i + 1] = res;
            i += 2
        })
        setCards(resCard.sort(() => Math.random() - 0.5))

        const interval = setInterval(() => {
            setTimer(timer => timer + 1);
        }, 1000);
        setIntervalId(interval);
        return () => {
            audio.pause()
            clearInterval(interval);
        }
    }, [])
    useEffect(() => {
        if (second !== -1) {
            if (cards[first].type === cards[second].type) {
                items[first] = true;
                items[second] = true;
                setItems(items);
                setProgress((items.filter(i => i === true).length / 24 * 100) | 0)

                setFirst(-1);
                setSecond(-1);
            } else {
                setTimeout(() =>  {
                    setFirst(-1);
                    setSecond(-1);
                }, 1000)
            }
        }
    }, [second])
    useEffect(() => {
        if (progress === 100) {
            clearInterval(intervalId)
            setIntervalId(-1);
        }
    }, [progress])
    useEffect(() => {
        if (audio) {
            volume ? audio.play() : audio.pause()
        }
    }, [volume])
    useEffect(() => {
        document.title = 'КьюАй - Игра Пары'
    }, [])

    const handleClick = (number) => {
        if (!items[first] && !items[second]) {
            if (first === -1) {
                setFirst(number)
            } else if (second === -1) {
                if (first !== number) {
                    setSecond(number)
                }
            }
        }
    }

    const renderProgress = () => {
        const style = {
            width: `${progress}%`
        }

        return (
            <span className="CardGame-progress">
                <div style={style} className="CardGame-progress-full"></div>
            </span>
        )
    }

    const renderCards = () => {
        return cards.map((card, i) =>
            <Card key={`card_${i}`}
                  Icon={card.icon}
                  isOpened={first === i || second === i || items[i]}
                  onClick={() => handleClick(i)}/>
        )
    }

    return (
        <Window>
            <div className="CardGame-top">
                <div className="CardGame-top-left">
                    <div className="CardGame-top-item">
                        <TimerOutlinedIcon/>
                        <span>Время: {(timer / 60) | 0}:{(timer % 60) < 10 ? `0${timer % 60}` : (timer % 60)}</span>
                    </div>
                    <div className="CardGame-top-item" onClick={() => setVolume(!volume)}>
                        {volume ? (<><VolumeUpOutlinedIcon/> Включен</>) : (<><VolumeOffOutlinedIcon/> Выключен</>)}
                    </div>
                    <div className="CardGame-top-item">
                        <SpeedOutlinedIcon/> <span>Прогресс: </span> {renderProgress()}
                    </div>
                </div>
                <CircleButton Icon={CloseIcon} onClick={() => navigate(TRAINERS_PAGE)}/>
            </div>
            <div className="CardGame-grid">
                {renderCards()}
            </div>
        </Window>
    )
}
